module.exports = __webpack_public_path__ + "static/media/local_parking_white_on_green_24dp.29837c09.svg";